export default __webpack_public_path__ + "static/059-0c86c8d905e86ae5c42566bd43f8c95f.jpg";